@if (label) {
  <p-floatLabel [variant]="floatLabelVariant">
    <bs-autocomplete
      bsFloatLabelCompat
      inputId="resource"
      [ngModel]="selectedResource()"
      [items]="result() ?? []"
      [dropdown]="!readonly"
      [requireSelection]="true"
      [disabled]="disabled || readonly"
      [minLength]="0"
      [displayWith]="getDisplayName"
      [compareWith]="compareByCode"
      (queryChange)="onQueryChange($event)"
      (selected)="onSelect($event)"
      (focused)="onInputFocus()"
      (blurred)="onBlur()" data-testid="selected-resource-autocomplete">
      <ng-template bsItem let-item>
        <span data-testid="country-item">{{ item.name }}</span>
      </ng-template>
    </bs-autocomplete>
    <label for="resource">{{ label }}</label>
  </p-floatLabel>
} @else {
  <bs-autocomplete
    bsFloatLabelCompat
    inputId="resource"
    [ngModel]="selectedResource()"
    [items]="result() ?? []"
    [dropdown]="!readonly"
    [requireSelection]="true"
    [disabled]="disabled || readonly"
    [minLength]="0"
    [displayWith]="getDisplayName"
    [compareWith]="compareByCode"
    (queryChange)="onQueryChange($event)"
    (selected)="onSelect($event)"
    (focused)="onInputFocus()"
    (blurred)="onBlur()" data-testid="selected-resource-autocomplete-2">
    <ng-template bsItem let-item>
      <span data-testid="country-item">{{ item.name }}</span>
    </ng-template>
  </bs-autocomplete>
}
